import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	textColorLabel: {
		id: 'company-hub.card-extensions.card-config.text-color-field.title',
		defaultMessage: 'Text color',
		description:
			'A visible text label for the cards text color section of the link cards config panel that informs the user that they can change the text color on the card.',
	},
});
